import { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

import ContextNLCode from './ContextNLCode';
import transformKeys from '../insurance-nlcode/util/transformKeys';

import useCart from 'hook/useCart';

import LayoutNLExt from './LayoutNLExt';
import usePkg from 'hook/usePkg';
import { useNLCode } from 'api/getNLCode';

const currDate = new Date();

function InsuranceNLcode() {
  const { options } = usePkg();
  const { addItems } = useCart();
  const [alcode, setAlcode] = useState('');
  const [parseData, setParseData] = useState([]);
  const [policyDate, setPolicyDate] = useState(currDate);
  const [pkg, setPkg] = useState(options[0]);
  const [disabled, setDisabled] = useState(true);
  const [isPass, setIsPass] = useState(false);
  const { refetch } = useNLCode(undefined, alcode);
  const [toggle, setToggle] = useState(true);
  const [employer, setEmployer] = useState('');
  const [employerId, setEmployerId] = useState('');
  const [address1, setAddress1] = useState('');
  const [district, setDistrict] = useState('');
  const [area, setArea] = useState('');
  const [province, setProvince] = useState('');
  const [zipcode, setZipcode] = useState('');

  useEffect(() => {
    setDisabled(true);
    setIsPass(false);
  }, []);

  useEffect(() => {
    if (alcode.length === 13) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [alcode]);

  function getNamelist() {
    Swal.fire({
      title: 'กำลังดำเนินการ',
      timerProgressBar: true,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        refetch()
          .then((data) => {
            if (data.isError) {
              throw data.error;
            }
            if (process.env.NODE_ENV !== 'production') {
              console.log(data.data);
            }
            setParseData(transformKeys(data.data, policyDate, pkg?.value));
            Swal.fire('สำเร็จ', '', 'success');
          })
          .catch((err) => {
            Swal.close();
            let errMsg = handleAxios(err);
            Swal.fire('ล้มเหลว', `${errMsg !== '' ? errMsg : err?.response}`, 'error');
          });
      },
    });
  }

  function handleSubmit() {
    if (!toggle) {
      addItems([{ ...parseData[0], employer, employerId, address1, district, area, province, zipcode }]);
    } else {
      addItems(parseData);
    }
    setParseData([]);
    setDisabled(true);
    setIsPass(false);
    setAddress1('');
    setEmployer('');
    setEmployerId('');
    setDistrict('');
    setArea('');
    setProvince('');
    setZipcode('');
  }

  function handleAxios(err) {
    let errMsg;
    if (axios.isAxiosError(err)) {
      if (err.response?.data) {
        errMsg = err.response.data;
      }
    }
    return errMsg;
  }

  return (
    <ContextNLCode.Provider
      value={{
        addItems,
        alcode,
        setAlcode,
        policyDate,
        setPolicyDate,
        pkg,
        setPkg,
        isPass,
        disabled,
        getNamelist,
        handleSubmit,
        toggle,
        setToggle,
        parseData,
        employer,
        setEmployer,
        employerId,
        setEmployerId,
        address1,
        setAddress1,
        district,
        setDistrict,
        area,
        setArea,
        province,
        setProvince,
        zipcode,
        setZipcode,
      }}
    >
      <LayoutNLExt />
    </ContextNLCode.Provider>
  );
}

export default InsuranceNLcode;
